import Vue from 'vue';
import Vuex from 'vuex';
import ElementUI from 'element-ui';
import Nl2br from 'vue-nl2br';
import VueMoment from 'vue-moment';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VueMoment);

Vue.component('nl2br', Nl2br);



// WEBPACK FOOTER //
// ./src/vue.js